/**
 * Initialize if not using SSR
 */
import {GoogleAnalyticsHelper} from '../helpers/googleAnalytics.helper';
import RestaurantProvider from './restaurant.provider';
import restaurantApi from '../api/restaurant.api';
import {setRestaurantCode} from '../actions/restaurant.action';

const initClient = (store) => {
  GoogleAnalyticsHelper.initialize(__CONFIG__.restaurantCode);
  store.dispatch(setRestaurantCode(__CONFIG__.restaurantCode));
  return restaurantApi.getRestaurant(__CONFIG__.restaurantCode)
    .then(restaurant => {
      return {
        restaurant: new RestaurantProvider(__CONFIG__.restaurantCode, restaurant)
      };
    });
};

const initAsyncProvider = (store, preloadedState) => {
  if (__CLIENT__) {
    return initClient(store);
  }

  GoogleAnalyticsHelper.initialize(preloadedState.restaurant.meta.code);
  return Promise.resolve({
    restaurant: new RestaurantProvider(preloadedState.restaurant.meta.code, preloadedState.restaurant)
  });
};

const init = (store, preloadedState) => {
  // Initialize providers that don't require async here

  const otherProviders = {};

  return initAsyncProvider(store, preloadedState)
    .then((providers) => {
      return Object.assign({}, providers, otherProviders);
    });
};

export default init;



// WEBPACK FOOTER //
// ./providers/initProviders.js